import swaggerClient from '../shared/swagger';

class Api {
  constructor() {
    this.client = null;
  }

  getParams(specsParams, params) {
    const parameters = {};
    for (let i = 0; i < specsParams.length; i++) {
      const param = specsParams[i];
      switch (param.in) {
        case 'header':
        case 'query':
        case 'path': {
          parameters[param.name] = params[param.name];
          break;
        }
        case 'body': {
          if (param.schema.type === 'array') {
            parameters[param.name] = params.body;
          } else {
            parameters[param.name] = {};
            let properties = param.schema && param.schema.properties ? param.schema.properties : {};
            properties = Object.keys(properties);
            for (let p = 0; p < properties.length; p++) {
              const property = properties[p];
              if (params[property]) {
                parameters[param.name][property] = params[property];
              }
            }
          }
          break;
        }
        default:
          break;
      }
    }

    return parameters;
  }

  getFormattedRequest(method, specPath, _params = {}) {
    const params = _params;
    params['X-Id-Token'] = null;

    let path = this.client.spec.paths[specPath]; // find matched path
    path = path[method]; // find matched 'method' object
    path.parameters = path.parameters || [];

    const request = {};
    request.parameters = this.getParams(path.parameters, params);
    // { request.tag } = path.tags[0];
    [request.tag] = path.tags;
    // request.tag = path.tags[0];
    request.operationId = path.operationId;
    return request;
  }

  getList(specPath, params = {}) {
    return new Promise((resolve, reject) => {
      swaggerClient.getClient().then((client) => {
        this.client = client;
        if (client) {
          const request = this.getFormattedRequest('get', specPath, params);
          this.performRequest(request.tag, request.operationId, request.parameters).then((resp) => {
            resolve(resp);
          }).catch((error) => {
            reject(error);
          });
        } else {
          resolve(null);
        }
      });
    });
  }

  get(specPath, params = {}) {
    return new Promise((resolve, reject) => {
      swaggerClient.getClient().then((client) => {
        this.client = client;
        if (client) {
          const request = this.getFormattedRequest('get', specPath, params);
          this.performRequest(request.tag, request.operationId, request.parameters).then((resp) => {
            resolve(resp);
          }).catch((error) => {
            reject(error);
          });
        } else {
          resolve(null);
        }
      });
    });
  }

  post(specPath, params = {}) {
    return new Promise((resolve, reject) => {
      swaggerClient.getClient().then((client) => {
        this.client = client;
        if (client) {
          const request = this.getFormattedRequest('post', specPath, params);
          this.performRequest(request.tag, request.operationId, request.parameters).then((resp) => {
            resolve(resp);
          }).catch((error) => {
            reject(error);
          });
        } else {
          resolve(null);
        }
      });
    });
  }

  put(specPath, params = {}) {
    return new Promise((resolve, reject) => {
      swaggerClient.getClient().then((client) => {
        this.client = client;
        if (client) {
          const request = this.getFormattedRequest('put', specPath, params);
          this.performRequest(request.tag, request.operationId, request.parameters).then((resp) => {
            resolve(resp);
          }).catch((error) => {
            reject(error);
          });
        } else {
          resolve(null);
        }
      });
    });
  }

  delete(specPath, params = {}) {
    return new Promise((resolve, reject) => {
      swaggerClient.getClient().then((client) => {
        this.client = client;
        if (client) {
          const request = this.getFormattedRequest('delete', specPath, params);
          this.performRequest(request.tag, request.operationId, request.parameters).then((resp) => {
            resolve(resp);
          }).catch((error) => {
            reject(error);
          });
        } else {
          resolve(null);
        }
      });
    });
  }

  performRequest(tag, operationId, params) {
    return new Promise((resolve, reject) => {
      this.client.apis[tag][operationId](params).then((resp) => {
        resolve(resp.obj);
      }, (error) => {
        reject(error.response);
      });
    });
  }
}

export default Api;



// WEBPACK FOOTER //
// ./app/src/services/Api.js